var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedCaseStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23333 0C2.79775 0 0 2.79775 0 6.23333C0 9.66891 2.79775 12.4667 6.23333 12.4667C9.66891 12.4667 12.4667 9.66891 12.4667 6.23333C12.4667 2.79775 9.66891 0 6.23333 0ZM9.13256 5.10264L5.65349 8.58171C5.53752 8.69767 5.39256 8.75566 5.2476 8.75566C5.10264 8.75566 4.95767 8.69767 4.84171 8.58171L3.04419 6.81318C2.81225 6.58124 2.81225 6.21884 3.04419 5.9869C3.27612 5.75496 3.63853 5.75496 3.87047 5.9869L5.2331 7.34953L8.30628 4.27636C8.53822 4.04442 8.90062 4.04442 9.13256 4.27636C9.35 4.50829 9.35 4.8707 9.13256 5.10264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCaseStatus);
export default __webpack_public_path__ + "static/media/completedCaseStatus.08fe37cbe73a4cc9fca76b892e839f81.svg";
export { ForwardRef as ReactComponent };